import { ICON_COLOR } from '@zep-us/zus/tokens';
import { SparklingFillIcon, TrashIcon } from '@/icons';
import { IconButton } from '@/ui_v3';
import { Checkbox } from '@/ui_v3/components/control/checkbox';
import { cn } from '@/utils/tailwind.util';
export const BuildAiGeneratedResultItemSkeleton = () => {
  return <div className="box-border flex w-full flex-col gap-[10px] self-stretch rounded-[16px] bg-default p-lg shadow-xs" data-sentry-component="BuildAiGeneratedResultItemSkeleton" data-sentry-source-file="BuildAiGeneratedResultItemSkeleton.tsx">
      <div className="item-center flex justify-between">
        <SkeletonRectangle width={320} height={26} data-sentry-element="SkeletonRectangle" data-sentry-source-file="BuildAiGeneratedResultItemSkeleton.tsx" />
        <div className="flex items-center gap-md">
          <IconButton variant="outlined" intent="neutral" size="2xs" className="opacity-[0.54]" data-sentry-element="IconButton" data-sentry-source-file="BuildAiGeneratedResultItemSkeleton.tsx">
            <TrashIcon size="xs" fill={ICON_COLOR.neutral} data-sentry-element="TrashIcon" data-sentry-source-file="BuildAiGeneratedResultItemSkeleton.tsx" />
          </IconButton>
          <Checkbox checked={false} disabled data-sentry-element="Checkbox" data-sentry-source-file="BuildAiGeneratedResultItemSkeleton.tsx" />
        </div>
      </div>
      <SkeletonRectangle width={220} height={26} data-sentry-element="SkeletonRectangle" data-sentry-source-file="BuildAiGeneratedResultItemSkeleton.tsx" />
      <div className="flex items-center gap-xs">
        <SparklingFillIcon size="xs" fill={ICON_COLOR.neutral} data-sentry-element="SparklingFillIcon" data-sentry-source-file="BuildAiGeneratedResultItemSkeleton.tsx" />
        <SkeletonRectangle width={130} height={18} data-sentry-element="SkeletonRectangle" data-sentry-source-file="BuildAiGeneratedResultItemSkeleton.tsx" />
      </div>
    </div>;
};
const SkeletonRectangle = ({
  width,
  height
}: {
  width: number;
  height: number;
}) => {
  const widthClass = `w-[${width}px]`;
  const heightClass = `h-[${height}px]`;
  return <div className={cn('bg-gradient-to-r from-gray-300 to-gray-50', 'animate-pulse', widthClass, heightClass)} data-sentry-component="SkeletonRectangle" data-sentry-source-file="BuildAiGeneratedResultItemSkeleton.tsx" />;
};